import INavBar from '@src/component/INavBar'
import {USER_MANAGE} from '@src/constant'
import {goto} from '@src/route'
import CommonService from '@src/service/commonService'
import {getItemObj} from '@src/util/store'
import {Space} from 'antd-mobile'
import {Flex} from 'antd-mobile-v2'
import React, {useEffect, useState} from 'react'
import './index.scss'
import {Rebate} from "@src/type";
import AssureService from "@service/AssureService";

function Home() {
	const {name, phone, dealerName, userType, storeName, isExperiment,dealerSource} =
		getItemObj('userInfo')
	const baseRoute = [
		{
			id: 1,
			name: '分享分期购车二维码',
			path: '/qr-code',
			isShow: userType === USER_MANAGE || dealerSource === 'zsmoto' || dealerSource === 'ktm',
		},
		{
			id: 2,
			name: '查看客户进件',
			path: '/customer-into',
			isShow: true,
		},
		{
			id: 3,
			name: '查看客户留资',
			path: '/leave-info',
			isShow: dealerSource === "ktm" || dealerSource === "zsmoto",
		},
		{
			id: 4,
			name: '金融方案计算器',
			path: '/counter',
			isShow: true,
		},
		{
			id: 5,
			name: '归档',
			isShow: true,
			path: '/archive'
		}
	]

	const [rebate, setRebate] = useState<Rebate>({allRebate: 0, rebateSettled: 0, unsettledRebate: 0})

	useEffect(() => {
		const getUser = async () => {
			await CommonService.userDetail().catch(() => {
				goto('/login')
			})
		}
		getUser()


		AssureService.getRebate().then((rs: any) => {
			setRebate(rs)
		})

	}, [])

	return (
		<>
			<INavBar title={dealerName} isRight isBack={false}/>
			<div className="content">
				<Space direction="vertical" style={{'--gap': '16px', width: '100%'}}>
					{/* <div className="rebate-box">
						<div className="row">
							<div>
								<div className="label">累计返利</div>
								<div className="v1">￥{rebate.allRebate}</div>
							</div>
						</div>
						<div className="row" style={{marginTop: '20px'}}>
							<div className="col">
								<div className="label">已结算返利</div>
								<div className="v2">￥{rebate.rebateSettled}</div>
							</div>
							<div className="col">
								<div className="label">未结算返利</div>
								<div className="v2">￥{rebate.unsettledRebate}</div>
							</div>
						</div>
					</div> */}
					<div className="user-bar">
						<span>{name}</span>
						<span>{phone}</span>
						<div className="reset-pwd-bt" onClick={() => goto('/forgot')}>修改密码</div>
					</div>
					{userType !== USER_MANAGE && (
						<div className="text-white">所属经销商：{dealerName}</div>
					)}
					{userType !== USER_MANAGE && (
						<div className="text-white">所属门店：{storeName}</div>
					)}

					<Flex wrap="wrap" justify="between">
						{baseRoute.map(
							(route) =>
								route.isShow && (
									<div
										className="base-route"
										key={route.id}
										onClick={() => goto(route.path)}
									>
										{route.name}
										<span style={{paddingLeft: 6}}>{'>'}</span>
									</div>
								)
						)}
					</Flex>
				</Space>
			</div>
		</>
	)
}

export default Home
